module.exports = __webpack_public_path__ + "static/media/student-level-use.86e69ef6.jpg";